import PersonIcon from "@mui/icons-material/Person";
import { Avatar, Badge, BoxProps, Skeleton, styled } from "@mui/material";
import { UserDto } from "dto/user-dto";
import * as React from "react";

function stringToColor(str: string) {
  let hash = 0;
  let i;

  for (i = 0; i < str.length; i += 1) {
    hash = str.charCodeAt(i) + ((hash << 5) - hash);
  }

  let color = "#";

  for (i = 0; i < 3; i += 1) {
    const value = (hash >> (i * 8)) & 0xff;
    color += `00${value.toString(16)}`.slice(-2);
  }

  return color;
}

const ActiveBadge = styled(Badge)(({ theme }) => ({
  "& .MuiBadge-badge": {
    backgroundColor: "#44b700",
    color: "#44b700",
    boxShadow: `0 0 0 2px ${theme.palette.background.paper}`,
  },
}));

const BlockedBadge = styled(Badge)(({ theme }) => ({
  "& .MuiBadge-badge": {
    backgroundColor: "#ff0000",
    color: "#ff0000",
    boxShadow: `0 0 0 2px ${theme.palette.background.paper}`,
  },
}));

type UserAvatarProps = {
  user?: UserDto;
} & BoxProps;

export const UserAvatar: React.FC<UserAvatarProps> = (props) => {
  if (!props.user) {
    return (
      <Skeleton variant="circular" width={64} height={64} />
    )
  }

  const avatar = (
    <Avatar sx={{ bgcolor: stringToColor(props.user.username), ...styles.avatar }}>
      <PersonIcon fontSize="large" sx={{color: "background.paper"}} />
    </Avatar>
  );

  if (props.user.active) {
    return (
      <ActiveBadge
        overlap="circular"
        anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
        badgeContent=" "
      >
        {avatar}
      </ActiveBadge>
    );
  }

  return (
    <BlockedBadge
      overlap="circular"
      anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
      badgeContent=" "
    >
      {avatar}
    </BlockedBadge>
  );
};

const styles = {
  avatar: {
    width: 64,
    height: 64,
  },
};
